import vue from '@/main'
import messages from '@/constants/messages'

export default {
  error ({ msg, timeout = 5000, position = 'toast-top-right', title = messages.TITULO_ERROR }) {
    vue.$toastr(messages.TIPO_ERROR, {
      title,
      msg,
      clickClose: true,
      timeout,
      position
    })
  },
  warning ({ msg, timeout = 5000, position = 'toast-top-right', title = messages.TITULO_WARNING }) {
    vue.$toastr(messages.TIPO_WARNING, {
      title,
      msg,
      clickClose: true,
      timeout: msg && msg.length > 60 ? 7000 : timeout,
      position
    })
  },
  success ({ msg, timeout = 5000, position = 'toast-top-right', title = messages.TITULO_SUCCESS }) {
    vue.$toastr(messages.TIPO_SUCCESS, {
      title,
      msg,
      clickClose: true,
      timeout,
      position
    })
  }
}
